import { withPointLists } from '@/features/risk-slides/lib/risk-simulation-tables'
import { orderXClient } from '@/service/client'
import {
  ApiRequest,
  RiskSimulationRequest,
  RiskSimulationResponse,
  ServerMessage,
} from '@/types/generated/public_api'

export async function runRiskSimulation(
  req: RiskSimulationRequest
): Promise<RiskSimulationResponse> {
  const body: ApiRequest = { riskSimulation: req }
  const { data } = await orderXClient.post<ServerMessage>('/api', body)
  const result = data.data?.riskSimulationResult
  if (result?.success) return withPointLists(await resolveOffloaded(result.success))
  if (result?.error) throw new Error(result.error.message)
  throw new Error('No simulation result returned')
}

/**
 * A result too large to return inline arrives as only `resultUrl`: a short-lived
 * presigned S3 URL to the protobuf-encoded response, served gzip (fetch inflates it).
 */
async function resolveOffloaded(response: RiskSimulationResponse): Promise<RiskSimulationResponse> {
  if (!response.resultUrl) return response
  const res = await fetch(response.resultUrl)
  if (!res.ok) throw new Error(`Simulation result download failed (${res.status})`)
  return RiskSimulationResponse.decode(new Uint8Array(await res.arrayBuffer()))
}
